var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconApparel = function SvgIconApparel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m4 7.3-.667.367a.65.65 0 0 1-.5.066.61.61 0 0 1-.4-.3L1.1 5.1a.65.65 0 0 1-.067-.5.61.61 0 0 1 .3-.4L5.166 2h1.167q.15 0 .242.092a.33.33 0 0 1 .091.241v.334q0 .55.392.941Q7.449 4 8 4t.941-.392.392-.941v-.334q0-.15.092-.241A.33.33 0 0 1 9.666 2h1.167l3.833 2.2a.61.61 0 0 1 .3.4.65.65 0 0 1-.066.5l-1.334 2.333a.58.58 0 0 1-.391.292.72.72 0 0 1-.509-.075L12 7.317v6.016a.65.65 0 0 1-.192.475.65.65 0 0 1-.475.192H4.666a.65.65 0 0 1-.475-.192.65.65 0 0 1-.191-.475z"
  })));
};
export default SvgIconApparel;